import {isString} from 'ramda-adjunct';

import {Nullish} from 'shared/web';

// The report link is always an absolute Cebia web URL served over HTTPS, so anything else —
// relative path, empty/whitespace string, a non-HTTPS scheme, a non-Cebia origin (including
// the `https://cz.cebia.com@attacker.example` credentials obfuscation), — must fail closed.
// `isSafeUrl` from shared/web cannot be reused here: it is a same-origin return-URL guard
// and the Cebia report link is cross-origin by definition.
const CEBIA_APEX_HOSTNAME = 'cebia.com';

function isCebiaHttpsUrl(url: string) {
  try {
    const parsed = new URL(url);

    return (
      parsed.protocol === 'https:' &&
      parsed.username === '' &&
      parsed.password === '' &&
      (parsed.hostname === CEBIA_APEX_HOSTNAME ||
        parsed.hostname.endsWith(`.${CEBIA_APEX_HOSTNAME}`))
    );
  } catch {
    return false;
  }
}

// Single source of truth for the banner guard. The web widget, the print widget, and
// Specification's break-line bookkeeping must all agree — if they diverged, a hidden
// banner would leave the section above without a divider (or draw a duplicate one).
export function canShowCebiaAutotracer(
  cebiaSmartCodeUrl: string | Nullish
): cebiaSmartCodeUrl is string {
  return isString(cebiaSmartCodeUrl) && isCebiaHttpsUrl(cebiaSmartCodeUrl);
}
